import { fetchRequest } from "@providers/conect";

const createEmpresaZonaApi = async (data) => {
  try {
    const url = `empresas-zonas/create`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateEmpresaZonaApi = async (id, data) => {
  try {
    const url = `empresas-zonas/update/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewEmpresasZonasApi = async (data) => {
  try {
    const url = `empresas-zonas/view`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllEmpresasZonasApi = async () => {
  try {
    const url = `empresas-zonas/all`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteEmpresaZonaApi = async (id) => {
  try {
    const url = `empresas-zonas/delete/${id}`;
    const response = await fetchRequest(url, {
      method: "DELETE"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const bulkCreateEmpresasZonasApi = async (data) => {
  try {
    const url = `empresas-zonas/bulk-create`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  createEmpresaZonaApi,
  updateEmpresaZonaApi,
  viewEmpresasZonasApi,
  getAllEmpresasZonasApi,
  deleteEmpresaZonaApi,
  bulkCreateEmpresasZonasApi
};